import { makeStyles } from "tss-react/mui";
import { MiPlaceholderArea } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  ENTITY_NAMES,
} from "@miplatform/constants";
import { getContrastColor, isEmpty } from "@miplatform/utils";
import { Box, Typography } from "@mui/material";
import { Footer } from "../Footer/Footer";
import { useInspectionCreationViewModel } from "./useInspectionCreationViewModel";

export function InspectionCreation({
  home = {},
  selectedInspectionTemplate = {},
  onCancel = () => {},
  onSubmit = () => {},
}) {
  const { id: homeId } = home;
  const {
    name: inspectionTemplateName,
    shortName,
    color,
  } = selectedInspectionTemplate;

  const { classes, theme } = useStyles({ color });

  const { isLoading, createInspection } = useInspectionCreationViewModel({
    homeId,
    selectedInspectionTemplate,
    onSubmit,
  });

  const noTemplateSelected = isEmpty(selectedInspectionTemplate);
  const submitDisabled = isLoading || noTemplateSelected;

  return (
    <Box className={classes.homeOwnerRequestContainer}>
      {noTemplateSelected ? (
        <MiPlaceholderArea
          text={`No ${ENTITY_NAMES.INSPECTION_TEMPLATE} Selected`}
          helperText={`Select a ${ENTITY_NAMES.INSPECTION_TEMPLATE.toLowerCase()} to get started.`}
        />
      ) : (
        <Box className={classes.homeOwnerRequestContent}>
          <Box className={classes.header}>
            <Box className={classes.shortNameContainer}>
              <Typography
                fontSize={theme.fontSize.xsmall}
                color={getContrastColor(color)}
              >
                {shortName}
              </Typography>
            </Box>
            <Typography fontWeight={theme.fontWeight.semiBold}>
              1.{inspectionTemplateName}
            </Typography>
          </Box>
        </Box>
      )}
      <Footer
        show
        sticky
        height={50}
        actions={[
          {
            name: "Cancel",
            variant: BUTTON_VARIANTS.TEXT,
            color: BUTTON_COLORS.BLACK,
            onClick: onCancel,
          },
          {
            name: "Schedule",
            variant: BUTTON_VARIANTS.CONTAINED,
            onClick: createInspection,
            disabled: submitDisabled,
          },
        ]}
      />
    </Box>
  );
}

const useStyles = makeStyles()((theme, { color } = {}) => ({
  homeOwnerRequestContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    width: "100%",
    gap: theme.spacing(2.5),
  },
  homeOwnerRequestContent: {
    backgroundColor: theme.palette.grey.mediumLight,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 4, 4),
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    height: "fit-content",
    border: `1px solid ${theme.palette.grey.mediumLight}`,
  },
  header: {
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "center",
    padding: theme.spacing(4, 0, 1),
  },
  shortNameContainer: {
    backgroundColor: color,
    borderRadius: theme.spacing(0.5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 20,
    minWidth: 20,
    width: "fit-content",
    padding: theme.spacing(0, 1),
  },
}));
